import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CustomizedYAxisLabel } from 'domain/shared/core/chart';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { foundationColors } from 'framework/ui/themes';

interface BurndownChartProps {
  data: any[];
}

const BurndownChart: React.FC<BurndownChartProps> = ({ data }) => {
  return (
    <Box
      sx={{ width: '50%', height: '400px', backgroundColor: 'background.paper', alignItems: 'center', borderRadius: 1 }}
    >
      <Box my={1} sx={{ alignItems: 'center', width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Typography variant="h5">Burndown and project completion, %</Typography>
      </Box>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis tick={{ fontSize: 12 }} dataKey="statusUpdate" padding={{ left: 30, right: 30 }} />
          <YAxis tick={{ fontSize: 12 }} label={<CustomizedYAxisLabel label="Hours / % Completion" />} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="budgetUsedHours"
            stroke={foundationColors.info}
            name="Burndown (hours)"
            strokeWidth={2}
            dot={{ r: 4 }}
          />
          <Line
            type="monotone"
            dataKey="scopeCompletionPercentage"
            stroke={foundationColors.success}
            name="Project Completion %"
            strokeWidth={2}
            dot={{ r: 4 }}
          />
          <Legend />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default BurndownChart;
